import React from "react";
import styled from "styled-components";

type Props = {
  page: number;
  scansTotal: number;
  numClickNav: (num: number) => void;
};

export default function UnitScanLiNav({
  page,
  scansTotal,
  numClickNav,
}: Props) {
  const ind = page - 1;
  const prevNav = () => {
    if (ind > 0) {
      numClickNav(ind - 1);
    }
  };
  const nextNav = () => {
    if (ind <= scansTotal - 2) {
      numClickNav(ind + 1);
    }
  };
  return (
    <LiNav>
      <span onClick={() => numClickNav(0)}>&lt;&lt;</span>
      <span onClick={() => prevNav()}>&lt;</span>
      <span onClick={() => nextNav()}>&gt;</span>
      <span onClick={() => numClickNav(scansTotal - 1)}>&gt;&gt;</span>
    </LiNav>
  );
}

const LiNav = styled.div`
  margin-top: 0.5rem;
  &&& span {
    display: inline-block;
    cursor: pointer;
    margin-right: 0.5rem;
  }
`;
